import { render } from "./workflowboard-importexport.vue?vue&type=template&id=e9a5f9de"
import script from "./workflowboard-importexport.vue?vue&type=script&lang=js"
export * from "./workflowboard-importexport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__